<template>
  <div class="content" :style="{touchAction: cover? 'none' :'auto'}">
		<div class="allContent">
			<div class="cover" v-show="cover">
				<div class="coverContent">
					<div>用户服务协议</div>
					<div class="protocol">
						<div>一、服务信息</div>
						<span>本测试工具提供的所有信息（包括但不限于护肤方式建议）是基于您的皮肤检测结果做出的，不建议以此作为医疗、健康状况的诊断依据，也不可替代医学治疗。我们无法保证您对使用本服务而得到的建议完全满意，我们不担保服务的及时性、安全性、准确性、真实性、完整性。</span>
						<div>二、隐私政策</div>
						<span>本政策仅适用于{{companyName}}的产品或服务。</span>
<!--						<span>最近更新日期：2019年4月17日。</span>-->
						<div>引言</div>
						<span>我们非常重视您的隐私和个人信息保护。若您想了解您的个人信息利用方式，请仔细阅读《隐私政策》（下称“本政策"）。</span>
						<span>本政策适用于我们所收集的个人信息，包括我们通过官方网站、在线商城、线下柜台、微信公众号、微信小程序等途径收集的个人信息。</span>
						<span>您选择使用我们的服务，即表示您已充分理解本政策的全部内容，并同意本政策以及本政策的更新，并同意我们根据本政策收集、使用、储存和共享您的个人信息。若您不同意本政策或其任何一部分，请停止使用我们的服务。</span>
						<span>本政策将帮助您了解以下内容：</span>
						<span>1.我们如何收集和使用您的个人信息</span>
						<span>2.我们如何使用Cookie和同类技术</span>
						<span>3.我们如何共享、转让、公开披露您的个人信息</span>
						<span>4.我们如何保护您的个人信息</span>
						<span>5.您的权利</span>
						<span>6.您的个人信息如何存储及在全球范围转移</span>
						<span>7.本政策如何更新</span>
						<span>8.如何联系我们</span>
						<div>一、我们如何收集和使用您的个人信息</div>
						<div>1.为您提供购物服务</div>
						<span>当您注册用户时，为完成创建账号，您可能需要提供以下信息：您的用户名、年龄/出生日期、电话号码、电子邮箱地址、创建的用户名和密码等。如果您仅使用浏览、搜索等基本服务，您不需要注册成为我们的会员及提供上述信息。在注册过程中，如果您提供以下额外信息，将有助于我们给您提供更好的服务和体验：通讯地址、性别等。但如果您不提供这信息，将不会影响使用本服务的基本功能。</span>
<!--						<div>2)为您查找附近的门店</div>-->
<!--						<span>当您通过我们的网站、微信公众号或微信小程序查询我们的门店信息时，我们会收集并处理与您的实际位置相关的信息，如移动设备发送的GPS信号。我们也会使用各类技术来进行定位，例如您的设备发散的感应数据可提供比如您附近WiFi接人点、近场通信(NFC)和蜂窝塔等相关信息。</span>-->
						<div>2.开展数据分析和研究，改善我们的产品或服务</div>
						<span>为了开展数据分析和研究并改善我们向您提供的服务，当您与我们的网站、微信公众号或微信小程序互动时，我们可能收集相关信息，以及您是如何使用该等网站、微信公众号和微信小程序的。</span>
						<div>1)网站</div>
						<span>我们可能收集您浏览的各网页的相关信息，以及您是如何使用各网站的。每次您浏览我们的网站，数据会从您的浏览器发送到我们的服务器。此类信息有助优化我们的服务，提升您在我们的网站、微信公众号和微信小程序的个性化体验。此类信息具体包括：</span>
						<span>•您的IP地址；</span>
						<span>•浏览日期和时间；</span>
						<span>•转引URL（即访客是从哪个网址转至我们网站的）；</span>
						<span>•在我们的网站浏览的网页以及进行的相关操作；</span>
						<span>•设备和浏览器相关信息（浏览器类型和版本、操作系统等）。</span>
						<div>2)商品展示、个性化推荐、发送促销营销信息</div>
						<span>为改善我们的产品或服务、向您提供个性化的信息搜索及交易服务，我们会根据您的设备信息、位置信息、订单信息，提取您的浏览、搜索偏好、位置信息等特征，基于特征标签进行间接人群画像并展示、推送信息。为便于向您推荐更适合的护肤产品，我们可能会通过肌肤测试收集您的肌肤信息，包括但不限于斑点、皱纹、肤质的情况。如果您不想接受我们给您发送的商业广告，您可随时通过相应产品退订功能取消。在不透露单个用户隐私资料的前提下，我们会对整个用户数据库进行分析并对用户数据库进行商业上的利用。我们会始终致力于在充分保护您个人信息的前提下，为您提供更优质的体验和服务。</span>
						<div>3.其他用途</div>
						<span>您的个人信息还可能被用于以下用途：</span>
						<span>•改进我们的产品和提升您在我们网站、微信公众号、微信小程序、门店的用户体验；</span>
						<span>•评估网站、微信公众号、微信小程序、产品以及服务的使用；</span>
						<span>•分析我们的广告、竞赛以及促销的有效性；</span>
						<span>•使网站、微信公众号、微信小程序、门店的使用更轻松并且更好地设计研发产品或服务，以满足您的兴趣和需求；</span>
						<span>•建议我们认为您可能感兴趣的产品或服务（包括相关第三方的产品或服务）；</span>
						<span>•向您提供参加竞赛或促销的机会；</span>
						<span>•向您发送您所要求的信息、产品或样品；</span>
						<span>•回复您的询问或评论。</span>
						<div>4.征得授权同意的例外</div>
						<span>根据相关法律法规规定，以下情形中收集您的个人信息无需征得您的授权同意：</span>
						<span>1)与国家安全、国防安全有关的；</span>
						<span>2)与公共安全、公共卫生、重大公共利益有关的；</span>
						<span>3)与犯罪侦查、起诉、审判和判决执行等有关的；</span>
						<span>4)出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</span>
						<span>5)所收集的个人信息是您自行向社会公众公开的；</span>
						<span>6)从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</span>
						<span>7)根据您的要求签订合同所必需的；</span>
						<span>8)用于维护所提供的产品或服务的安全稳定运行所必需的，例如发现、处置产品或服务的故障；</span>
						<span>9)为合法的新闻报道所必需的；</span>
						<span>10)学术研究机构基于公共利益开展统计或学术研究所必要，且对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的；</span>
						<span>11)法律法规规定的其他情形。</span>
						<span>如我们停止运营我们的网站或服务，我们将及时停止继续收集您个人信息的话动，将停止运营的通知以逐一送达或公告的形式通知您，对所持有的个人信息进行删除或匿名化处理。</span>
						<div>二、我们如何使用Cookie和同类技术</div>
						<div>1.Cookie</div>
						<span>我们的网站或网上商城使用Cookie，以便您能登录我们的服务，并允许设定您特定的服务选项。运用Cookie技术，网站或网上商城能够为您提供更加周到的个性化服务。您可以选择接受或拒绝Cookie。您可以通过修改浏览器设置的方式拒绝Cookie。如果您选择拒绝Cookie，则您可能无法登录或使用依赖于Cookie的我们的网站或网上商城服务或功能。</span>
						<div>2.Cookie同类技术</div>
						<span>保有您的使用记录当您使用我们官方网站或网上商城提供的服务时，服务器会自动记录一些信息，包括URL、IP地址、浏览器的类型和使用的语言以及访问日期和时间等。</span>
						<div>三、我们如何共享、转让、公开披露您的个人信息</div>
						<span>除本政策披露的情况外我们不会主动共享或转让您的个人信息至第三方，如存在其他共享或转让您的个人信息情形时，我们会征得您的明示同意。随着我们业务的持续发展，我们有可能进行合并、收购、资产转让等交易，我们将告知您相关情形，按照法律法规及不低于本政策所要求新的控制者继续保护您的个人信息。</span>
						<div>1.共享</div>
						<span>我们不会与本公司以外的任何公司、组织和个人分享您的个人信息，但以下情况除外：</span>
						<span>1)在获取明确同意的情况下共享：获得您的明确同意后，我们会与其他第三方共享您的个人信息。</span>
						<span>2)我们可能会根据法律法规规定，或按政府主管部门的强制性要求，对外共享您的个人信息。</span>
						<span>3)与服务供应商或合作伙伴共享：仅为实现本政策中声明的目的，我们聘用各类服务供应商或与合作伙伴进行合作。我们可能会与服务供应商或合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户体验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。</span>
<!--						<span>4)与服务供应商或合作伙伴共享：仅为实现本政策中声明的目的，我们聘用各类服务供应商或与合作伙伴进行合作。我们可能会与服务供应商或合作伙伴共享您的某些个人信息，以提供更好的客户服务和用户休验。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享提供服务所必要的个人信息。</span>-->
						<div>2.转让</div>
						<span>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</span>
						<span>1)在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他第三方转让您的个人信息；</span>
						<span>2)在涉及合并、收购或破产清算时，如涉及到个人信息转让，我们会在要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织重新向您征求授权同意。</span>
						<div>3.公开披露</div>
						<span>我们仅会在以下情况下，公开披露您的个人信息：</span>
						<span>1)获得您明确同意后；</span>
						<span>2)基于法律的披露：在法律、法律程序、诉讼或政府主管部门强制性要求的情况下，我们可能会公开披露您的个人信息。</span>
						<span>3)违反相关协议规则：如果我们确定您出现违反相关协议规则的情况，或为保护我们及我们关联公司用户或公众的人身财产安全免遭侵害，我们可能依据法律法规或相关协议规则征得您同意的情况下披露关于您的个人信息，包括相关违规行为以及我们已对您采取的措施。</span>
						<span>4)共享、转让、公开披露个人信息时事先征得授权同意的例外</span>
						<span>以下情形中，共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</span>
						<span>a)与国家安全、国防安全有关的；</span>
						<span>b)与公共安全、公共卫生、重大公共利益有关的；</span>
						<span>c)与犯罪侦查、起诉、审判和判决执行等有关的；</span>
						<span>d)出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到您本人同意的；</span>
						<span>e)您自行向社会公众公开的个人信息；</span>
						<span>f)从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</span>
						<span>根据法律规定，共享、转让经去标识化处理的个人信息，且确保数据接收方无法复原并重新识别个人信息主体的，不属于个人信息的对外共享、转让及公开披露行为，对此类数据的保存及处理将无需另行向您通知并征得您的同意。</span>
						<div>四、我们如何保护您的个人信息</div>
						<span>我们已使用符合业界标准的安全防护措施保护您提供的个人信息，防止数据遭到未经授权访问、公开披露、使用、修改、损坏或丢失。我们会采取一切合理可行的措施，保护您的个人信息。</span>
						<span>我们会采取一切合理可行的措施，确保未收集无关的个人信息。我们只会在达成本政策所述目的所需的期限内保留您的个人信息，除非需要延长保留期或受到法律的允许。</span>
						<span>互联网并非绝对安全的环境，而且电子邮件、即时通讯等交流方式并未加密，我们强烈建议您不要通过此类方式发送个人信息。请使用复杂密码，协助我们保证您的账号安全。</span>
						<span>互联网环境并非绝对安全，我们将尽力确保或担保您发送给我们的任何信息的安全性。</span>
						<span>在不幸发生个人信息安全事件后，我们将按照法律法规的要求，及时向您告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知个人信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照益管部门要求，主动上报个人信息安全事件的处置情况。</span>
						<div>1.您的权利</div>
						<span>按照中国相关的法律、法规，我们保障您对自己的个人信息行使以下权利：</span>
						<span>1)访问您的个人信息</span>
						<span>您有权访问您的个人信息，法律法规规定的例外情况除外。如果您想行使数据访问权，可以通过以下方式自行访问：</span>
						<span>账户信息——如果您希望访问或编辑您的账户中的个人资料信息和支付信息、更改您的密码、添加安全信息或关闭您的账户等，您可以通过登录账号执行此类操作。</span>
						<span>2)订单信息</span>
						<span>您可以通过登录账号查阅或清除您的订单记录、交易记录等。更正您的个人信息。</span>
						<span>当您发现我们处理的关于您的个人信息有错误时，您可以登录网站、微信公众号或微信小程序，点击相应的功能按钮，进行数据的修改维护。我们将在30天内回复您的更正请求。</span>
						<span>3)删除您的个人信息</span>
						<span>在以下情形中，您可以向我们提出删除个人信息的请求：</span>
						<span>a)如果我们收集、使用您的个人信息，却未征得您的同意；</span>
						<span>b)如果我们处理个人信息的行为违反了与您的约定；</span>
						<span>c)如果您不再使用我们的产品或服务，或您注销了账号；</span>
						<span>d)如果我们不再为您提供产品或服务。</span>
						<span>若我们决定响应您的删除请求，我们还将同时通知从我们获得您的个人信息的实体，要求其及时删除，除非法律法规另有规定，或这实体获得您的独立授权。</span>
						<span>当您从我们的服务中删除信息后，我们可能不会立即在备份系统中删除相应的信息，但会在备份更新时删除这些信息。根据《网络安全法》的要求，在删除您的个人信息以后，与您相关的监测、记录网络运行状态、网络安全事件日志仍将留存不少于六个月。</span>
						<span>若要注销您的账号、支付功能，您可登录网站、微信公众号或微信小程序后，点击相应的注销功能按钮，进行个人账号的注销功能，当您注销账号后，我们将删除或匿名化处理您的个人信息。根据《网络安全法》的要求，在注销账户以后，与您相关的监测、记录网络运行状态、网络安全事件日志仍将留存不少于六个月。</span>
						<div>五、响应您的上述请求</div>
						<span>为保障安全，您可能需要提供书面请求，或以其他方式证明您的身份。我们可能会先要求您验证自己的身份，然后再处理您的请求。我们将在30天内做出答复。</span>
						<span>在以下情形中，按照法律法规要求，我们将无法响应您的请求：</span>
						<span>1.与国家安全、国防安全直接相关的；</span>
						<span>2.与公共安全、公共卫生、重大公共利益直接相关的；</span>
						<span>3.与犯罪侦查、起诉、审判和判决执行等直接相关的；</span>
						<span>4.有充分证据表明您存在主观恶意或滥用权利的；</span>
						<span>5.响应您的请求将导致您或其他个人、组织的合法权益受到严重损害的。</span>
						<span>6.涉及商业秘密的。</span>
						<div>六、如何联系我们</div>
						<span>如果您对本政策有任何疑问、意见或建议，通过以下方式与我们联系：</span>
            <span>电话：400-777-1516</span>
            <span>一般情况下，我们将在五个工作日内回复。</span>
					</div>
					<span @click="cover = !cover">我知道了</span>
				</div>
			</div>
			<div class="user_cover" v-show="is_user">
				<div class="user_coverContent">
					<div class="user_Content">
						<div class="user_title  flex align-start">
							<img style="" src="/static/images/skinAnalysis/sex.png" />
							<span>姓别</span>
						</div>
						<div class="flex justify-around sex line">
							<div>
								<img v-if="user_sex == 1" src="/static/images/skinAnalysis/man_checked.png" @click="chooseSex(1)" />
								<img v-if="user_sex == 0" src="/static/images/skinAnalysis/man.png" @click="chooseSex(1)" />
								<img class="checked" v-if="user_sex == 1" src="/static/images/skinAnalysis/checked.png" />
							</div>
							<div>
								<img v-if="user_sex == 0" src="/static/images/skinAnalysis/men_checked.png" @click="chooseSex(0)" />
								<img v-if="user_sex == 1" src="/static/images/skinAnalysis/men.png" @click="chooseSex(0)" />
								<img class="checked" v-if="user_sex == 0" src="/static/images/skinAnalysis/checked.png" />
							</div>
						</div>
						<div class="user_title flex align-start">
							<img style="" src="/static/images/skinAnalysis/age.png" />
							<span>年龄</span>
						</div>
						<div class=" line ">
							<div class="picker" @click="switchDate">{{user_age}}</div>
						</div>
						<div class="bun">
							<button type="default" class="user_assign" @click="chooseImage">确定</button>
							<button type="default" @click="change_user_cover" class="user_cancel">取消</button>
						</div>
					</div>
				</div>
			</div>

			<div class="content2">
				<div id="imgGroup" :style="{top:customBar+'px',height:imgGroupvh+'vh' }">
					<img class="logo logo-c" src="/static/images/skinAnalysis/logo-c.png" v-if="show_tip == false && orgtype != 'juzi'" />
					<img class="logo logo-j" src="/static/images/skinAnalysis/logo-j.png" v-if="show_tip == false && orgtype == 'juzi'" />
          			<div class="igContent">
						<div class="out1" :class="{animate1: interval}"></div>
						<div class="out2" :class="{animate2: interval}" :style="{backgroundImage: 'url(' + out2bg + ')'}"></div>
						<div>
							<div class="in" :style="{backgroundImage: 'url(' + img + ')', transform: 'rotate(' + rotate + 'deg)'}"></div>
							<div class="boxScan">
								<span class="scan" v-if="interval"></span>
							</div>
						</div>
					</div>
				</div>
				<div class="bottom bottom1" v-show="loading == false" :style="{height:bottomvh + 'vh'}">
					<div class="vtips">
						<div>{{vtipsTitle}}</div>
					</div>
					<div class="carefuls" v-show="loading == false">
						<div class="items" :style="itemscss" style="text-align: center;">
							<div class="spot"></div>不戴眼镜
						</div>
						<div class="items " :style="itemscss">
							<div class="spot"></div>无美颜
						</div>
						<div class="items " :style="itemscss">
							<div class="spot"></div>无刘海遮挡
						</div>
						<div class="items " :style="itemscss" style="text-align: center;">
							<div class="spot"></div>素颜<div style="display: inline-block; height: 16px; width: 2em;"></div>
						</div>
						<div class="items " :style="itemscss">
							<div class="spot"></div>面部占图比3/4
						</div>
						<div class="items " :style="itemscss">
							<div class="spot"></div>正面照片
						</div>
					</div>
					<div class="carefuls errorTips grid col-3" v-show="show_tip">
						<div class="items flex align-center" v-for="i in errorTip" :key="i">
							<img style="width: 16px; height: 16px;" src="/static/images/skinAnalysis/icon_error.png" />
							<span>{{i}}</span>
						</div>
					</div>
					<div class="vcamera" :style="vcameracss">
						<button @click="change_user_cover">
							<img style="width: 22px; height: 22px; padding: 12px; box-sizing:unset;" src="/static/images/skinAnalysis/camera.png" />
              				<span v-show="!show_tip">开启测肤</span>
							<span v-show="show_tip">重新测肤</span>
						</button>
					</div>
					<div class="bottomGroup" id="bottomGroup" v-show="show_tip == false">
						<div class="flex-jc-ac">
							<div class="agreement">
								<div id="agree_no" :class="{'agree': agree}" @click="changeAgree"></div>
								<div @click="changeAgree">我已阅读并同意</div>
								<div @click="openCover" style="text-decoration:underline; ">《用户隐私协议》</div>
							</div>
							<div class="bottomRecord" v-if="orgtype!='juzi'" @click="goRecords">
								<span></span>
								<span>测肤记录</span>
							</div>
						</div>
					</div>
				</div>

				<div class="bottom bottom2" v-show="loading">
					<div class="loading">{{loadingText}}</div>
				</div>
				<!-- 出生年月日 -->
				<div class="maskWrap" v-show="showDate">
					<div class="mask"></div>
					<van-datetime-picker v-model="currentDate" type="date" title="" :min-date="minDate" :max-date="maxDate"
						:formatter="formatter" @cancel="switchDate" @confirm="DateChange"/>
				</div>
			</div>
		</div>
    	<uploadFile ref="uploader" @uploadSuccess="uploadSuccess" />
	</div>
</template>

<script>
import { basepath, isWx, parametersCombine, isWeixin, fenxiang, isApp, webview_dataFn, webview_data  } from '../../assets/common/js/config'
import uploadFile from './uploadFile'
import { customRequestAjax } from "@/axiosApi";
import wx from 'weixin-js-sdk'
export default {
  name: "skinAnalysis",
  components: {
    uploadFile,
  },
  data() {
    return {
      //高度兼容
		imgGroupvh: 68,
		bottomvh: 34,
		logocss: '',
		itemscss: "",
		vcameracss: "",
		tip: ['不戴眼镜', '关掉美颜', '无刘海遮挡', '素颜', '面部占图比3/4'],
		tip2: ['面部占比3/4', '关掉美颜', '拍摄正面图片', '不戴眼镜'],
		img: require('../../../static/images/skinAnalysis/home.gif?v=1'),
		out1bg: require('../../../static/images/skinAnalysis/11.png'),
		out2bg: require('../../../static/images/skinAnalysis/22.png'),
		rotate: '0',
		radio: 'A',
		interval: '',
		loadingText: '图片处理中...',
		errorImage: false,
		loading: false,
		vtipsTitle: "亲，满足以下条件测肤效果更好哦！",
		show_tip: false,
		errorTip: [],
		isLocal: false,
		is_user: false,
		agree: true,
		cover: false,
		user_cover: true,
		user_sex: 1,
		user_age: '1987-10-23',
		tips: ['正在识别面部',
			'正在识别五官',
			'正在分析肤龄',
			'正在分析肤质',
			'正在分析肤色',
			'正在分析敏感度',
			'正在分析皱纹',
			'正在分析黑眼圈',
			'正在分析黑头',
			'正在分析毛孔',
			'正在分析痘痘',
			'正在分析色斑',
			'正在分析光滑度'
		],
		version: 1,
		bgColor: "#FFF",
		appType: 'weixin',
		appTypeCate: 'xcx',
		customBar: 0,
		isUserInfo: 0,
		company: '深圳市宜远智能科技有限公司',
		appTitle: '宜远智能AI测肤',
		power: '深圳市宜远智能科技有限公司',
        showDate: false,
        minDate: new Date(1920, 9, 1),
        maxDate: new Date(),
        currentDate: new Date(),
		checkInfo: {
			integralNum: null,
			limit: -1
		},
      orgtype: null, // 机构类别
		companyName: '西安创客村电子商务有限责任公司'
    };
  },
  created() {
	  console.log('当前页面路径', window.location.href)
	// 重置数据项
	this.user_sex = 1
	sessionStorage.removeItem('sex')
	this.orgtype = this.$route.query.orgtype
	console.log('当前公司', this.orgtype)

	if (this.orgtype == 'juzi') {
		this.checkInfo = {
			integralNum: null,
			limit: 0
		}
		this.companyName = '西安巨子生物基因技术股份有限公司'
	} else {
		if (isWx == 3 && this.waptoken.waptoken && this.waptoken.waptoken == this.waptoken.tourists) {
			localStorage.setItem('htmlurl', window.location.href)
			window.location = '/login?routeval=html'
			return;
		}
	}

	this.share()
    if (this.orgtype != 'juzi') {
      this.check()
    }
  },
  methods: {
	share() {
		if (isWeixin()) {
			var arg = isApp(), shareInfo;
			shareInfo = {
				title: encodeURIComponent('皮肤测试'),
				desc: encodeURIComponent('AI皮肤测试，充分了解您你的皮肤状况！'),
				type: 'skinAnalysis',
				path: 'skinAnalysis',
				dataStr: 'type=skinAnalysis&emptybottle=emptybottle&orgtype=' + this.orgtype,
				imgx: this.staticImgUrl + 'Uploads/share/ndo1.png'
			}

			console.log('分享信息', shareInfo)

			if (arg.indexOf('xcx') >= 0) {
				shareInfo = {
					type: 'skinAnalysis',
					title: encodeURIComponent('皮肤测试'),
					link: basepath + 'skinAnalysis?path=' + (this.$route.query.path ? this.$route.query.path : '') + arg,
					img: this.staticImgUrl + 'Uploads/share/ndo1.png'
				}
				wx.miniProgram.postMessage({data: shareInfo})
			} else {
				fenxiang(shareInfo)
			}
		}
	},
	// 判断当前用户是否有测试机会
	check() {
		let url = 'Wxmall/YiYuanApi/checkUser'
		customRequestAjax(url).then((res) => {
			console.log(res.data)
			if (res.data.code == 200) {
				this.checkInfo = res.data
        if (res.data.gender) this.user_sex = res.data.gender
        if (res.data.agetime) this.user_age = res.data.agetime
			}
    });
	},
    //同意与否 用户隐私协议
    changeAgree() {
      if (!this.interval && !this.errorImage) {
        this.agree = !this.agree
      }
    },
    //打开用户隐私协议浏览
    openCover() {
      if (!this.interval && !this.errorImage) {
        this.cover = !this.cover
      }
    },
    //选择姓别
    chooseSex(sex) {
      this.user_sex = sex
	  sessionStorage.setItem('sex', sex)
    },
    // 时间选择 弹框的确认按钮
    formatter(type, val) {
      if (type === 'year') {
        return val + '年';
      }
      if (type === 'month') {
        return val + '月';
      }
      if (type === 'day') {
        return val + '日';
      }
      return val;
    },
    // 控制年龄显示隐藏
    switchDate() {
      this.showDate = !this.showDate
    },
    //选择年龄
    DateChange(e) {
      this.user_age = this.timeFormat(e)
      this.switchDate()
    },
    timeFormat(time) { // 时间格式化 2019-09-08
      let year, month, day;

      year = time.getFullYear();
      month = time.getMonth() + 1;
      day = time.getDate();

      return year + '-' + month + '-' + day
    },
    //打开用户信息录入框
    change_user_cover() {
		if (!this.agree) {
			this.$toast('请先阅读并同意用户隐私协议！')
			return false
		}
		if (this.checkInfo.limit == 1) { // 已达上限
			this.$dialog.confirm({
				message: '本次皮肤测试将消耗' + this.checkInfo.integralNum + '个金币，' + '确认测试？',
				className: 'collect_button_alert',
        cancelButtonColor: '#FC0324',
        confirmButtonColor: '#FFFCFC',
        cancelButtonText: '取消',
        confirmButtonText: '确定'
			}).then(() => {
				this.expend()
			}).catch(() => {})
			return
		} else if (this.checkInfo.limit == -1) { //
			this.$toast('正在请求，请稍后！')
			return
		} else if (this.checkInfo.limit == 0) {
			this.is_user = !this.is_user
		}
    },
	// 消耗金币
	expend() {
		let url = 'Wxmall/YiYuanApi/isSureLessCoins'
		customRequestAjax(url).then((res) => {
			console.log(res.data)
			if (res.data.code == 200) {
				this.is_user = !this.is_user
			} else {
				this.$dialog.alert({
					message: '金币不足，快去赚取更多金币吧',
					className: 'percen_button_alert',
					confirmButtonColor: '#FFFCFC',
					confirmButtonText: '去赚金币',
					closeOnPopstate: false,
					showCancelButton: true,
					cancelButtonText: '知道了'
				}).then(() => {
					let arg = isApp()
					if (arg == '') {
						window.location = '/integralTask'
					} else if (arg.indexOf('xcx') < 0) {
						window.ReactNativeWebView.postMessage(JSON.stringify({
							type: 'integralTask',
						}))
					} else {
						wx.miniProgram.navigateTo({url: '/pages/integral/integralTask/main'})
					}

				}).catch(() => {})
			}
      	});
	},
    // 选择图片
    chooseImage() {
		this.is_user = !this.is_user

		if (isWx == 2 || isWx == 5) {
			let u, isAndroid;

			u = navigator.userAgent;
			isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g

			if (isAndroid) { // 安卓APP上相机无法调起兼容性处理
        webview_dataFn(() => {
          window.ReactNativeWebView.postMessage(JSON.stringify({
            type: 'takephoto'
          }))
        }).then(() => {
          if (webview_data && webview_data.permissionGranted == true) {
            this.$refs.uploader.currentFile()
          }
        })

			} else {
				this.$refs.uploader.currentFile()
			}
		} else {
			this.$refs.uploader.currentFile()
		}
    },
	// 图片上传成功
    uploadSuccess(image) {
	  this.img = image
      this.toggleState(1)
      this.submitAnalsysi(image)
    },
    handlerError(err, tip) {
      this.errorImage = err
      this.interval = ''
      if (tip) {
        this.errorTip = tip
      }
    },
    submitAnalsysi(image) {
      let self = this, reqParam = {
        type: self.appTypeCate,
        image_type: 12,
        image: image,
        user_sex: self.user_sex,
        user_age: self.user_age,
      }, url = 'Wxmall/YiYuanApi/detect';

	  if (this.orgtype == 'juzi') {
		  url = 'Wxmall/YiYuanApickys/detect'
	  }


      customRequestAjax.post(url, reqParam).then((res) => {
		if (res.data.code == 0) {
			self.getResult(res.data.orderid)
			return false
		}
		if (res.data.code == 21001) {
			self.errorTip.push('找不到人脸')
			self.toggleState(2)
			return false
		}

		if (res.data.code == 21003) {
			if (res.data.analysis.image_detect) {
				let image = res.data.analysis.image_detect
				if (image.ratio) {
					self.errorTip.push('面部占比过小')
				}
				if (image.angle) {
					self.errorTip.push('面部倾斜过大')
				}
				if (image.blur) {
					self.errorTip.push('照片模糊')
				}
				if (image.has_fringe) {
					self.errorTip.push('有刘海遮挡')
				}
			} else {
				self.errorTip.push('图片质量不合格')
			}
			self.toggleState(2)
			return false
		} else {
			this.$toast('检测失败')
			self.toggleState(3)
		}
      });
    },
    getResult(id) {
		const self = this
		let url = 'Wxmall/YiYuanApi/detail?orderid=' + id
		if (this.orgtype == 'juzi') {
			url = url = 'Wxmall/YiYuanApickys/detail?orderid=' + id
		}

      	this.loadingText = '图像分析中'

        customRequestAjax(url).then((res) => {
          if (res.data.code === 0) {
            if (res.data.status == 0) {
              return
            }

            if (res.data.status == 2) {
              res.data.analysis.region = ''
              sessionStorage.setItem('detail_data', JSON.stringify(res))
              sessionStorage.setItem('detail_id', id)
              self.errorImage = false
              let query = parametersCombine()
              query.source = 'analysis'
              query.orderid = id
              query.sex = this.user_sex
              query.orgtype = this.orgtype
              this.$router.push({
                path: '/analysisDetail',
                query: query
              })
            } else if (res.data.status == -1) {
				let analysis = res.data.analysis, tip = [];
				if (analysis.code == 21001) {
					self.errorTip.push('找不到人脸')
					self.toggleState(2)
					return false
				} else if (analysis.code == 21003) {
					if (analysis.image_detect) {
						let image = analysis.image_detect

						if (image.ratio) {
							self.errorTip.push('面部占比过小')
						}
						if (image.angle) {
							self.errorTip.push('面部倾斜过大')
						}
						if (image.blur) {
							self.errorTip.push('照片模糊')
						}
						if (image.has_fringe) {
							self.errorTip.push('有刘海遮挡')
						}

					} else {
						self.errorTip.push('图片质量不合格')
					}
					self.toggleState(2)
					return false
				} else {
					this.$toast('检测失败')
					self.toggleState(3)
				}
              self.loadingText = tip
            } else {
              self.loadingText = '获取数据异常'
            }
          }
      });
    },
    toggleState(status) {
      const self = this
      if (status == 1) {
        //上传中
        self.loading = true
        self.interval = 1
        self.errorImage = false
        self.show_tip = true
        self.loadingText = '图片处理中...'
      } else if (status == 2) {
        //检测不合格的
        self.show_tip = true
        self.vtipsTitle = '照片不合格项'
        self.loading = false
        self.interval = 0
        self.errorImage = true
      } else {
        self.loading = false
        self.interval = 0
        self.errorImage = true
      }
    },
	goRecords() {
		let query = parametersCombine()
		this.$router.push({
			path: 'skinRecords',
			query: query
		})
	}
  }
}
</script>
<style lang="scss">
	.percen_button_alert .van-dialog__footer .van-button--large {
		padding: 0.07rem 0;
	}
</style>
<style scoped lang="scss">
@import "../../assets/css/skinAnalysis/index.scss";

.maskWrap {
  z-index: 100;
  .mask {
    z-index: 100;
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.5);
  }
}
.van-picker {
  z-index: 100;
}
.flex {
	display: flex;
}
.align-start {
	align-items: flex-start;
}
.justify-around {
	justify-content: space-around;
}
</style>



// WEBPACK FOOTER //
// src/components/skinAnalysis/index.vue